import qs from 'qs';
import { axios, path } from './config';
import { channelTypes, messageStatusType } from 'appConstants';

export const sendMessage = ({
  candidateId,
  text,
  actingUser,
  threadId,
  twilioTemplateId,
  contentVariables,
  selectedChannel,
}) => {
  const requestBody = { candidate_id: candidateId, text };
  if (actingUser) {
    requestBody.acting_user = actingUser;
  } else {
    requestBody.thread_id = threadId;
  }

  if (selectedChannel === channelTypes.WHATS_APP && twilioTemplateId) {
    requestBody.twilio_template_id = twilioTemplateId;
    if (contentVariables) {
      requestBody.content_variables = JSON.parse(contentVariables);
    }
    return axios.post(path.SEND_MESSAGE, requestBody);
  }

  return axios.post(path.SEND_MESSAGE, requestBody);
};

const getThreadFilter = ({ searchedUserName, messageOptions, id }) => {
  const threadFilter = [];
  if (id !== '') {
    threadFilter.push({ fieldName: 'candidateId', type: 'Equals', value: id });
  }
  if (searchedUserName !== '') {
    threadFilter.push({
      fieldName: 'userName',
      type: 'Like',
      value: searchedUserName,
    });
  }

  if (messageOptions === messageStatusType.UNREAD) {
    threadFilter.push({ fieldName: 'read', type: 'Equals', value: false });
  }
  return threadFilter;
};

export const getThreads = ({
  pageNumber,
  inboxType,
  userName,
  messageOptions,
  campaignName,
  searchedUserName,
  inboxIdx,
  accountName,
  itemsPerPage,
  id,
}) => {
  const sort = messageOptions === messageStatusType.SENT ? '-sentTime' : '-time';
  const params = {
    username: userName,
    filter: JSON.stringify(getThreadFilter({ messageOptions, searchedUserName, id })),
    account_type: inboxType.toUpperCase(),
    items_per_page: itemsPerPage,
    page: pageNumber,
    sort,
    nocount: true,
  };
  if (campaignName !== '') {
    params.job_name = campaignName;
  }
  return axios.get(`${path.MESSAGE_THREADS}${qs.stringify(params)}`).then((response) => {
    response.messageOptions = messageOptions;
    response.inboxType = inboxType;
    response.inboxIdx = inboxIdx;
    response.accountName = accountName;
    return response;
  });
};

export function getConversation({ candidateId, markAsRead, threadId, actingUser }) {
  const requestBody = {
    id: candidateId,
    page: 1,
    items_per_page: 100,
    nocount: true,
    do_not_mark_read: !markAsRead,
    show_link_clicks: true,
  };
  if (threadId) {
    requestBody.thread_id = threadId;
  }
  if (actingUser) {
    requestBody.acting_user = actingUser;
  }
  return axios.post(path.GET_MESSAGES_API, requestBody);
}

export const markMessageRead = ({ messageId }) =>
  axios.get(path.MESSAGE, {
    params: { message_id: messageId, status: 'markRead' },
  });

export function getThreadsWithUnreadMessages({ inboxType, username, page = 1, itemsPerPage }) {
  const params = {
    username,
    page,
    account_type: inboxType.toUpperCase(),
    items_per_page: itemsPerPage,
    sort: '-time',
    filter: JSON.stringify([{ fieldName: 'read', type: 'Equals', value: false }]),
    nocount: false,
  };
  return axios.get(`${path.MESSAGE_THREADS}${qs.stringify(params)}`);
}
